import { render, staticRenderFns } from "./MyBinds.vue?vue&type=template&id=1953a470&scoped=true"
import script from "./MyBinds.vue?vue&type=script&lang=js"
export * from "./MyBinds.vue?vue&type=script&lang=js"
import style0 from "./MyBinds.vue?vue&type=style&index=0&id=1953a470&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953a470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1953a470')) {
      api.createRecord('1953a470', component.options)
    } else {
      api.reload('1953a470', component.options)
    }
    module.hot.accept("./MyBinds.vue?vue&type=template&id=1953a470&scoped=true", function () {
      api.rerender('1953a470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/MyBinds.vue"
export default component.exports